export { BuyCallToAction } from './BuyCallToAction';



// WEBPACK FOOTER //
// ./ui/partials/buyCallToAction/index.js